import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { WellyMark } from "@/components/WellyMark";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center space-y-6 py-24 text-center">
      <WellyMark size={64} className="text-muted-foreground" />
      <h1 className="text-3xl font-bold tracking-tight">Nothing out here.</h1>
      <p className="max-w-sm text-muted-foreground">Welly checked — this page isn't on the pond.</p>
      <Button asChild>
        <Link to="/">Back to the start</Link>
      </Button>
    </div>
  );
}
